<template>
		<!-- Sidebar -->
		<div
      class="sidebar"
      id="sidebar"
      @click="onSidebarClick"
      @mouseenter="onMiniSidebarEnter"
      @mouseleave="onMiniSidebarLeave"
    >
			<!-- Logo -->
			<div class="sidebar-logo active">
        <router-link to="/" class="logo logo-normal">
          <img src="/assets/img/otobonik-logo.png" alt="Img">
        </router-link>
        <router-link to="/" class="logo logo-white">
          <img src="/assets/img/otobonik-logo.png" alt="Img">
        </router-link>
        <router-link to="/" class="logo-small">
          <img src="/assets/img/otobonik-small.png" alt="Img">
        </router-link>
				<a id="toggle_btn" >
					<i class="ti ti-chevrons-left" style="font-size:16px;"></i>
				</a>
			</div>
			<!-- /Logo -->

			<div class="modern-profile p-3 pb-0">
				<div class="text-center rounded bg-light p-3 mb-4 user-profile">
					<div class="avatar avatar-lg online mb-3">
						<img src="/assets/img/customer/customer15.jpg" alt="Img" class="img-fluid rounded-circle">
					</div>
					<h6 class="fs-14 fw-bold mb-1">Adrian Herman</h6>
					<p class="fs-12 mb-0">System Admin</p>
				</div>
				<div class="sidebar-nav mb-3">
					<ul class="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent" role="tablist">
						<li class="nav-item"><a class="nav-link active border-0" href="#">Menu</a></li>
						<li class="nav-item"><a class="nav-link border-0" href="chat.html">Chats</a></li>
						<li class="nav-item"><a class="nav-link border-0" href="email.html">Inbox</a></li>
					</ul>
				</div>
			</div>
			<div class="sidebar-header p-3 pb-0 pt-2">
				<div class="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
					<div class="avatar avatar-md onlin">
						<img src="/assets/img/customer/customer15.jpg" alt="Img" class="img-fluid rounded-circle">
					</div>
					<div class="text-start sidebar-profile-info ms-2">
						<h6 class="fs-14 fw-bold mb-1">Adrian Herman</h6>
						<p class="fs-12">System Admin</p>
					</div>
				</div>
				<div class="d-flex align-items-center justify-content-between menu-item mb-3">
					<div>
						<a href="index.html" class="btn btn-sm btn-icon bg-light">
							<i class="ti ti-layout-grid-remove"></i>
						</a>
					</div>
					<div>
						<a href="chat.html" class="btn btn-sm btn-icon bg-light">
							<i class="ti ti-brand-hipchat"></i>
						</a>
					</div>
					<div>
						<a href="email.html" class="btn btn-sm btn-icon bg-light position-relative">
							<i class="ti ti-message"></i>
						</a>
					</div>
					<div class="notification-item">
						<a href="activities.html" class="btn btn-sm btn-icon bg-light position-relative">
							<i class="ti ti-bell"></i>
							<span class="notification-status-dot"></span>
						</a>
					</div>
					<div class="me-0">
						<a href="general-settings.html" class="btn btn-sm btn-icon bg-light">
							<i class="ti ti-settings"></i>
						</a>
					</div>
				</div>
			</div>

      <div class="sidebar-inner slimscroll">
        <div id="sidebar-menu" ref="menu" class="sidebar-menu">
          <ul>
            <!-- Dashboard -->
            <li>
              <h6 class="submenu-hdr">Main</h6>
              <router-link to="/" active-class="active">
                <i class="ti ti-layout-dashboard me-1"></i>
                <span>Dashboard</span>
              </router-link>
            </li>

            <!-- Inventory Menu -->
            <li v-if="canViewInventoryMenu" class="submenu">
              <a href="#" @click.prevent="toggleMenu('inventory')"
                 :class="{ 'subdrop active': isOpen('inventory') }">
                <i class="ti ti-packages fs-16 me-2"></i>
                <span>Inventory</span>
                <span class="menu-arrow"></span>
              </a>
              <ul data-menu="inventory" :style="{ display: isOpen('inventory') ? 'block' : 'none' }">
                <li v-if="can('inventory.item', 'R')">
                  <router-link to="/items" active-class="active" >
                    <i class="ti ti-package me-1"></i>Item
                  </router-link>
                </li>
                <li v-if="can('inventory.variant', 'R')">
                  <router-link to="/variants" active-class="active" >
                    <i class="ti ti-list-details me-1"></i>Variant List
                  </router-link>
                </li>
                <li v-if="can('inventory.store_transfer', 'R')">
                  <router-link to="/store/transfer/list" active-class="active" >
                    <i class="ti ti-transfer me-1"></i>Store Transfer
                    <span
                      v-if="pendingTransferCount > 0"
                      class="badge bg-warning text-dark rounded-pill ms-1"
                    >{{ pendingTransferCount }}</span>
                  </router-link>
                </li>
                <li v-if="can('inventory.barcode_generator', 'R')">
                  <router-link to="/print/barcodes" active-class="active">
                    <i class="ti ti-barcode me-1"></i>Barcode
                  </router-link>
                </li>
                <li v-if="can('inventory.damage_item', 'R')">
                  <router-link to="/damage/item/list" active-class="active" >
                    <i class="ti ti-alert-triangle me-1"></i>Damage Item
                  </router-link>
                </li>
                <li v-if="canViewInventorySettingsMenu" class="submenu submenu-two">
                  <a
                    href="#"
                    @click.prevent="toggleNestedMenu('inventory-settings')"
                    :class="{ 'subdrop active': isNestedOpen('inventory-settings') }"
                  >
                    <i class="ti ti-settings me-1"></i>Settings
                    <span class="menu-arrow inside-submenu"></span>
                  </a>
                  <ul
                    data-menu="inventory-settings"
                    :style="{ display: isNestedOpen('inventory-settings') ? 'block' : 'none' }"
                  >
                    <li v-if="can('inventory.configuration', 'R')">
                      <router-link to="/invoice/setting/list" active-class="active">
                        <i class="ti ti-building me-1"></i>Business Info
                      </router-link>
                    </li>
                    <li v-if="can('inventory.category', 'R')">
                      <router-link to="/category" active-class="active">
                        <i class="ti ti-folders me-1"></i>Category
                      </router-link>
                    </li>
                    <li v-if="can('inventory.sub_category', 'R')">
                      <router-link to="/sub/category" active-class="active">
                        <i class="ti ti-folders me-1"></i>Sub Category
                      </router-link>
                    </li>
                    <li v-if="can('inventory.measurement_units', 'R')">
                      <router-link to="/measurement/unit" active-class="active">
                        <i class="ti ti-ruler-measure me-1"></i>Units
                      </router-link>
                    </li>
                    <li v-if="can('inventory.configuration', 'R')">
                      <router-link to="/attribute/list" active-class="active">
                        <i class="ti ti-list-check me-1"></i>Attributes
                      </router-link>
                    </li>
                    <li v-if="can('inventory.configuration', 'R')">
                      <router-link to="/inventory/store" active-class="active">
                        <i class="ti ti-building-store me-1"></i>Store
                      </router-link>
                    </li>
                    <li v-if="can('inventory.discount_campaign', 'R')">
                      <router-link to="/discount/campaigns" active-class="active">
                        <i class="ti ti-discount-2 me-1"></i>Discount
                      </router-link>
                    </li>
                    <li v-if="can('inventory.warehouse', 'R')">
                      <router-link to="/inventory/warehouse" active-class="active">
                        <i class="ti ti-building-warehouse me-1"></i>Warehouse
                      </router-link>
                    </li>
                    <li v-if="can('inventory.configuration', 'R')">
                      <router-link to="/vat/groups" active-class="active">
                        <i class="ti ti-receipt-tax me-1"></i>Vat Groups
                      </router-link>
                    </li>
                    <li v-if="can('inventory.configuration', 'R')">
                      <router-link to="/setting/list" active-class="active">
                        <i class="ti ti-adjustments me-1"></i>Configuration
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <!-- Sales Menu -->
            <li v-if="canViewSalesMenu" class="submenu">
              <a href="#" @click.prevent="toggleMenu('sales')"
                 :class="{ 'subdrop active': isOpen('sales') }">
                <i class="ti ti-shopping-cart fs-16 me-2"></i>
                <span>Sales</span>
                <span class="menu-arrow"></span>
              </a>
              <ul data-menu="sales" :style="{ display: isOpen('sales') ? 'block' : 'none' }">
                <li v-if="can('sales.pos', 'R')">
                  <router-link to="/pos" active-class="active" >
                    <i class="ti ti-device-laptop me-1"></i>POS
                  </router-link>
                </li>
                <li v-if="can('sales.sales_return', 'R')">
                  <router-link to="/sales/list" active-class="active" >
                    <i class="ti ti-arrow-back me-1"></i>Sales List
                  </router-link>
                </li>
                <li v-if="can('sales.sales_return', 'R')">
                  <router-link to="/sales/return/list" active-class="active" >
                    <i class="ti ti-arrow-back me-1"></i>Sales Return
                  </router-link>
                </li>
                <li v-if="can('sales.customer_due_receive', 'R')">
                  <router-link to="/customer/due/receive/list" active-class="active" >
                    <i class="ti ti-cash me-1"></i>Customer Due
                  </router-link>
                </li>
                <li v-if="can('sales.customer', 'R')">
                  <router-link to="/customers/list" active-class="active" >
                    <i class="ti ti-users me-1"></i>Customer
                  </router-link>
                </li>
                <li v-if="can('sales.invoice_print', 'R')">
                  <router-link to="/print/invoice" active-class="active">
                    <i class="ti ti-receipt me-1"></i>Invoice Printing
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Purchases Menu -->
            <li v-if="canViewPurchaseMenu" class="submenu">
              <a href="#" @click.prevent="toggleMenu('purchases')"
                 :class="{ 'subdrop active': isOpen('purchases') }">
                <i class="ti ti-shopping-bag fs-16 me-2"></i>
                <span>Purchases</span>
                <span class="menu-arrow"></span>
              </a>
              <ul data-menu="purchases" :style="{ display: isOpen('purchases') ? 'block' : 'none' }">
                <!-- <li v-if="can('purchase.purchase_entry', 'R')">
                  <router-link :to="{name: 'Requisition'}" active-class="active" >
                    <i class="ti ti-shopping-cart-plus me-1"></i>Purchase Requisition
                  </router-link>
                </li> -->
                <!-- <li v-if="can('purchase.purchase_entry', 'R')">
                  <router-link :to="{name: 'PurchaseOrder'}" active-class="active" >
                    <i class="ti ti-shopping-cart-plus me-1"></i>Purchase Order
                  </router-link>
                </li> -->
                <li v-if="can('purchase.purchase_entry', 'R')">
                  <router-link to="/batches" active-class="active" >
                    <i class="ti ti-shopping-cart-plus me-1"></i>Purchase Entry
                  </router-link>
                </li>
                <li v-if="can('purchase.purchase_return', 'R')">
                  <router-link to="/purchase/return/list" active-class="active" >
                    <i class="ti ti-arrow-back me-1"></i>Purchase Return
                  </router-link>
                </li>
                <li v-if="can('purchase.supplier_due_payment', 'R')">
                  <router-link to="/supplier/due/list" active-class="active" >
                    <i class="ti ti-credit-card-pay me-1"></i>Due Payment
                  </router-link>
                </li>
                <li v-if="can('purchase.supplier', 'R')">
                  <router-link to="/inventory/supplier" active-class="active" >
                    <i class="ti ti-users me-1"></i>Supplier
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Finance & Accounts Menu (Admin only) -->
            <li v-if="isAdmin" class="submenu">
              <a href="#" @click.prevent="toggleMenu('finance')"
                 :class="{ 'subdrop active': isOpen('finance') }">
                <i class="ti ti-currency-dollar fs-16 me-2"></i>
                <span>Finance & Accounts</span>
                <span class="menu-arrow"></span>
              </a>
              <ul data-menu="finance" :style="{ display: isOpen('finance') ? 'block' : 'none' }">
<!--                <li><router-link active-class="active" :to="{ name: 'BankAccountHeadList' }">Bank Account List</router-link></li>-->
                <li><router-link active-class="active" :to="{ name: 'ChartOfAccounts' }">Chart Of Accounts</router-link></li>
                <!-- <li><router-link active-class="active" :to="{ name: 'ChartOfAccountsList', params:{type:'receivable'} }">Bill Receivable List</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'ChartOfAccountsList', params:{type:'payable'} }">Bill Payable List</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'ChartOfAccountsList', params:{type:'income'} }">Income List</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'ChartOfAccountsList', params:{type:'expense'} }">Expense List</router-link></li> -->
                <li><router-link active-class="active" :to="{ name: 'DebitVoucher' }">Debit Voucher</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'CreditVoucher' }">Credit Voucher</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'JournalVoucher' }">Journal Voucher</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'ContraVoucher' }">Contra Voucher</router-link></li>
                <!-- <li><router-link active-class="active" :to="{ name: 'IncomeHeadList' }">Income Head List</router-link></li> -->
                <!-- <li><router-link active-class="active" :to="{ name: 'ExpenseHeadList' }">Expense Head List</router-link></li> -->
                <!-- <li><router-link active-class="active" :to="{ name: 'SupplierHeadList' }">Supplier Due Head List</router-link></li> -->
<!--                <li><router-link active-class="active" :to="{ name: 'BankAccountHeadList' }">Bank Account List</router-link></li>-->
                <!-- <li><router-link active-class="active" :to="{ name: 'CustomerHeadList' }">Customer Due Head List</router-link></li> -->
<!--                <li><router-link active-class="active" :to="{ name: 'IncomeHeadList' }">Income Head List</router-link></li>-->
<!--                <li><router-link active-class="active" :to="{ name: 'ExpenseHeadList' }">Expense Head List</router-link></li>-->
<!--                <li><router-link active-class="active" :to="{ name: 'SupplierHeadList' }">Supplier Due Head List</router-link></li>-->
<!--                <li>
                  <router-link active-class="active" :to="{ name: 'BankAccountHeadList' }">Bank Account List</router-link>
                </li>-->
<!--                <li><router-link active-class="active" :to="{ name: 'CustomerHeadList' }">Customer Due Head List</router-link></li>-->
                <li><router-link active-class="active" :to="{ name: 'AccountingReports' }">Accounting Reports</router-link></li>
                <!-- <li><router-link active-class="active" :to="{ name: 'CustomerHeadList' }">Customer Due Head List</router-link></li> -->

              </ul>
            </li>

            <!-- User Management Menu -->
            <li v-if="canViewUserMenu" class="submenu">
              <a href="#" @click.prevent="toggleMenu('user')"
                 :class="{ 'subdrop active': isOpen('user') }">
                <i class="ti ti-users fs-16 me-2"></i>
                <span>User Management</span>
                <span class="menu-arrow"></span>
              </a>
              <ul data-menu="user" :style="{ display: isOpen('user') ? 'block' : 'none' }">
                <li v-if="can('rbac.user', 'R')">
                  <router-link to="/users/" active-class="active" >
                    <i class="ti ti-receipt me-1"></i>Users
                  </router-link>
                </li>
                <li v-if="can('rbac.role', 'R')">
                  <router-link to="/roles/" active-class="active" >
                    <i class="ti ti-receipt me-1"></i>Roles
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Backup Menu -->
            <li v-if="isAdmin">
              <a
                href="#"
                class="menu-link"
                :class="{ disabled: backingUp }"
                @click.prevent="downloadBackup"
              >
                <i class="ti ti-database-export fs-16 me-2"></i>
                <span>{{ backingUp ? 'Backing up…' : 'Backup' }}</span>
              </a>
            </li>

            <!-- Reports Menu -->
            <li v-if="canViewReports">
              <router-link
                to="/item/return/report"
                class="menu-link"
                :class="{ active: $route.path === '/item/return/report' }"
                active-class="active"
              >
                <i class="ti ti-report fs-16 me-2"></i>
                <span>Reports</span>
              </router-link>
            </li>

            <!-- Finance & Accounts Menu -->
            <!-- <li>
              <router-link
                :to="{name: 'FinancialReport'}"
                class="menu-link"
                :class="{ active: $route.path === '/account/report/finance' }"
                active-class="active"
              >
                <i class="ti ti-report fs-16 me-2"></i>
                <span>Financial Reports</span>
              </router-link>
            </li> -->
            <!-- <li class="submenu">
              <a href="#" @click.prevent="toggleMenu('finance_report')"
                 :class="{ 'subdrop active': isOpen('finance_report') }">
                <i class="ti ti-currency-dollar fs-16 me-2"></i>
                <span>Finance Report</span>
                <span class="menu-arrow"></span>
              </a>
              <ul data-menu="finance_report" :style="{ display: isOpen('finance_report') ? 'block' : 'none' }">
                <li><router-link active-class="active" :to="{ name: 'LedgerReportForm' }">Ledger</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'TrialBalanceReport' }">Trial Balance</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'IncomeExpenseReport' }">Income & Expense</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'IncomeStatement' }">Income Statement</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'BalanceSheetReport' }">Balance Sheet</router-link></li>
                <li><router-link active-class="active" :to="{ name: 'OwnerEquityReport' }">Owner Equity</router-link></li>
              </ul>
            </li> -->
          </ul>
        </div>
      </div>

      <div class="sidebar-footer">
          © 2026 <a href="https://entrancelogic.com/" target="_blank" rel="noopener">Entrance Logic Systems</a>
      </div>
    </div>
		<!-- /Sidebar -->
</template>

<script>
import { can as canAccess, isAdminUser } from "@/helpers/permission";
import apiUrls from "@/urls";

// Pages whose path doesn't start with their menu link's path, e.g. /item/create belongs to Item (/items).
const PATH_ALIASES = [
  [/^\/item\/(size|color)\b/, '/measurement/unit'],
  [/^\/item\/(?!return\/)/, '/items/'],
  [/^\/batch\//, '/batches/'],
  [/^\/return\/item\b/, '/sales/return'],
  [/^\/discount\/campaigns\//, '/discount/campaigns'],
];

// "/customers/list/" -> "/customers": list pages and their create/edit pages then share a prefix.
function normalizePath(path) {
  return (path || '').split(/[?#]/)[0].replace(/\/+$/, '').replace(/\/list$/, '');
}

export default {
  name: "Sidebar",

  data() {
    return {
      openMenu: null,
      openNestedMenus: {},
      backingUp: false,
      pendingTransferCount: 0,
    };
  },

  computed: {
    isAdmin() {
      return isAdminUser();
    },

    canViewUserMenu() {
      return this.can('rbac.user', 'R') || this.can('rbac.role', 'R');
    },

    canViewReports() {
      return (
        this.can('sales.report.sale_return', 'R') ||
        this.can('inventory.report.stock', 'R') ||
        this.can('purchase.report.batch', 'R') ||
        this.can('sales.report.sale', 'R') ||
        this.can('purchase.report.buy', 'R') ||
        this.can('inventory.report.low_stock', 'R') ||
        this.can('sales.report.customer_due', 'R') ||
        this.can('purchase.report.supplier_payment', 'R')
      );
    },

    canViewInventorySettingsMenu() {
      return (
        this.can('inventory.category', 'R') ||
        this.can('inventory.sub_category', 'R') ||
        this.can('inventory.measurement_units', 'R') ||
        this.can('inventory.warehouse', 'R') ||
        this.can('inventory.discount_campaign', 'R') ||
        this.can('inventory.configuration', 'R')
      );
    },

    canViewInventoryMenu() {
      return (
        this.can('inventory.item', 'R') ||
        this.can('inventory.variant', 'R') ||
        this.can('inventory.barcode_generator', 'R') ||
        this.can('inventory.damage_item', 'R') ||
        this.can('inventory.store_transfer', 'R') ||
        this.canViewInventorySettingsMenu
      );
    },

    canViewSalesMenu() {
      return (
        this.can('sales.pos', 'R') ||
        this.can('sales.sales_return', 'R') ||
        this.can('sales.customer_due_receive', 'R') ||
        this.can('sales.customer', 'R') ||
        this.can('sales.invoice_print', 'R')
      );
    },

    canViewPurchaseMenu() {
      return (
        this.can('purchase.purchase_entry', 'R') ||
        this.can('purchase.purchase_return', 'R') ||
        this.can('purchase.supplier_due_payment', 'R') ||
        this.can('purchase.supplier_due_payment', 'R')
      );
    },

  },

  watch: {
    '$route.fullPath'() {
      this.closeMobileMenu();
      this.$nextTick(this.markCurrentLink);
      this.refreshPendingTransfers();
    },
  },

  mounted() {
    this.$nextTick(this.markCurrentLink);
    this.refreshPendingTransfers();
  },

  methods: {
    // Submenu routes are flat (e.g. /account/debit/voucher/create is not a child of /account/debit/voucher),
    // so router-link's active class only covers the list page itself. Mark the closest link instead.
    findCurrentLink(links, path) {
      let best = null;
      let bestLength = -1;
      links.forEach((link) => {
        const linkPath = normalizePath((link.getAttribute('href') || '').replace(/^#/, ''));
        if (!linkPath) return;
        if ((path === linkPath || path.startsWith(`${linkPath}/`)) && linkPath.length > bestLength) {
          best = link;
          bestLength = linkPath.length;
        }
      });
      return best;
    },

    markCurrentLink() {
      const menu = this.$refs.menu;
      if (!menu) return;
      const links = [...menu.querySelectorAll('ul[data-menu] a[href]')];
      links.forEach((link) => link.classList.remove('current-link'));

      const path = normalizePath(this.$route.path);
      let current = this.findCurrentLink(links, path);
      if (!current) {
        const alias = PATH_ALIASES.find(([from]) => from.test(path));
        if (alias) current = this.findCurrentLink(links, normalizePath(path.replace(alias[0], alias[1])));
      }
      if (!current) {
        // A page outside every submenu (Dashboard, Reports): don't leave the last menu open and highlighted.
        this.openMenu = null;
        return;
      }

      current.classList.add('current-link');
      const menuEl = current.closest('ul[data-menu]');
      const menuKey = menuEl?.dataset.menu;
      if (menuKey === 'inventory-settings') {
        this.openMenu = 'inventory';
        this.openNestedMenus = { ...this.openNestedMenus, 'inventory-settings': true };
      } else if (menuKey) {
        this.openMenu = menuKey;
      }
    },

    toggleMenu(menuKey) {
      // Collapsed (icon-only) mode hides open submenus until expand-menu is on.
      if (document.body.classList.contains('mini-sidebar')) {
        document.body.classList.add('expand-menu');
      }
      if (this.openMenu === menuKey) {
        this.openMenu = null;
        if (menuKey === 'inventory') {
          this.openNestedMenus = { ...this.openNestedMenus, 'inventory-settings': false };
        }
      } else {
        this.openMenu = menuKey;
      }
    },

    toggleNestedMenu(menuKey) {
      if (document.body.classList.contains('mini-sidebar')) {
        document.body.classList.add('expand-menu');
      }
      // Nested settings live under Inventory — keep the parent open.
      if (menuKey === 'inventory-settings') {
        this.openMenu = 'inventory';
      }
      this.openNestedMenus = {
        ...this.openNestedMenus,
        [menuKey]: !this.openNestedMenus[menuKey],
      };
    },

    isNestedOpen(menuKey) {
      return Boolean(this.openNestedMenus[menuKey]);
    },

    onMiniSidebarEnter() {
      if (document.body.classList.contains('mini-sidebar')) {
        document.body.classList.add('expand-menu');
      }
    },

    onMiniSidebarLeave() {
      if (document.body.classList.contains('mini-sidebar')) {
        document.body.classList.remove('expand-menu');
      }
    },

    // A page link (not a "#" submenu toggle) closes the mobile menu, even when it is the page already open.
    onSidebarClick(event) {
      const link = event.target.closest('a[href]');
      const href = link?.getAttribute('href') || '';
      if (href && !href.startsWith('#') && link.target !== '_blank') this.closeMobileMenu();
    },

    // Undoes what the theme script (public/assets/js/script.js) does when #mobile_btn opens the mobile menu.
    closeMobileMenu() {
      document.documentElement.classList.remove('menu-opened');
      document.querySelectorAll('.main-wrapper.slide-nav').forEach((el) => el.classList.remove('slide-nav'));
      document.querySelectorAll('.sidebar-overlay.opened').forEach((el) => el.classList.remove('opened'));
    },

    isOpen(menuKey) {
      return this.openMenu === menuKey;
    },

    can(code, requiredLevel) {
      return canAccess(code, requiredLevel);
    },

    async refreshPendingTransfers() {
      if (!this.can('inventory.store_transfer', 'R')) {
        this.pendingTransferCount = 0;
        return;
      }
      try {
        const response = await this.$axios.get(apiUrls.store_transfer.get, {
          params: { status: 'pending', direction: 'in' },
        });
        this.pendingTransferCount = response.data?.pending_inbound || 0;
      } catch (_) {
        /* badge is best-effort */
      }
    },

    backupFilename(response) {
      const disposition = response.headers['content-disposition'] || '';
      const match = /filename\*?=(?:UTF-8''|")?([^";]+)/i.exec(disposition);
      if (match) {
        try {
          return decodeURIComponent(match[1].replace(/"/g, '').trim());
        } catch (_) {
          return match[1].replace(/"/g, '').trim();
        }
      }
      const host = (window.location.hostname || 'backup').split('.')[0] || 'backup';
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const stamp = `${pad(now.getDate())}_${pad(now.getMonth() + 1)}_${now.getFullYear()}_${pad(now.getHours())}_${pad(now.getMinutes())}`;
      return `${host}_backup_${stamp}.zip`;
    },

    async downloadBackup() {
      if (this.backingUp) return;
      this.backingUp = true;
      try {
        const response = await this.$axios.get(apiUrls.backup.export, { responseType: 'blob' });
        const contentType = (response.headers['content-type'] || '').toLowerCase();
        if (contentType.includes('application/json')) {
          const text = await response.data.text();
          const detail = JSON.parse(text);
          throw new Error(detail.error || detail.detail || 'Backup failed');
        }
        const blob = new Blob([response.data], { type: 'application/zip' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.backupFilename(response);
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Backup failed:', error);
        window.alert(error?.message || 'Backup failed. Please try again.');
      } finally {
        this.backingUp = false;
      }
    },
  }
};
</script>

<style>
/* Tighter than the theme's spacing (16px between menus, 10px/8px item padding). */
.sidebar #sidebar-menu > ul > li {
  margin-bottom: 4px;
}

.sidebar #sidebar-menu > ul > li > a {
  padding-top: 7px;
  padding-bottom: 7px;
}

.sidebar #sidebar-menu > ul > li.submenu ul {
  padding: 2px 0;
}

.sidebar #sidebar-menu > ul > li.submenu ul li a {
  padding-top: 5px;
  padding-bottom: 5px;
}

/* Nested Inventory → Settings */
.sidebar #sidebar-menu > ul > li.submenu ul li.submenu-two > a {
  display: flex;
  align-items: center;
}

.sidebar #sidebar-menu > ul > li.submenu ul li.submenu-two > ul {
  padding-left: 12px;
}

.sidebar #sidebar-menu > ul > li.submenu ul li.submenu-two > ul li a {
  padding-top: 4px;
  padding-bottom: 4px;
}

/* The theme only colours the dot of the current submenu item; highlight it like a selected menu. */
.sidebar #sidebar-menu > ul > li.submenu ul li a.current-link,
.sidebar #sidebar-menu > ul > li.submenu ul li a.active {
  color: #FE9F43;
  background: rgba(254, 159, 67, 0.08);
  border-radius: 5px;
}

.sidebar #sidebar-menu > ul > li.submenu ul li a.current-link::after {
  background: #FE9F43;
  border: 2px solid #FDB;
}

.sidebar #sidebar-menu > ul > li.submenu ul li a::after {
  top: 50%;
  transform: translateY(-50%);
}

.sidebar #sidebar-menu .submenu-hdr {
  margin-bottom: 6px;
}
</style>
